import React from 'react';

type Props = {
  image: any;
};

export default function SmallAvatar({ image }: Props) {
  return (
    <div className="relative h-[2.3rem] w-[2.3rem]">
      <div className="relative flex h-full w-full items-center justify-center overflow-hidden rounded-full border-2 border-primary-800 bg-[#FF7A001A]">
        <img src={image} className="h-4 w-4 rounded-full object-cover" />
      </div>
    </div>
  );
}
